import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AuthForm from './AuthForm';
import { changeField as authChangeField, initializeForm, register } from '../../modules/auth/authSlice';
import { check } from '../../modules/auth/userSlice';

const RegisterForm = () => {
    const dispatch = useDispatch();
    const { form, auth, authError, user } = useSelector(({ auth, user }) => ({
        form: auth.register,
        auth: auth.auth,
        authError: auth.authError,
        user: user.user,
    }));

    //const error = null;
    // 이럴 때 useState 사용하는 것임.
    const [error, setError] = useState(null);

    const onChange = (e) => {
        const { name, value } = e.target;
        dispatch(
            authChangeField({
                form: 'register',
                key: name,
                value,
            }),
        );
    };

    const onSubmit = (e) => {
        e.preventDefault();
        const { username, password, passwordConfirm } = form; // e.target에서 가져오는 것이 아니라 state에서 가져와야 한다.
        // 하나라도 비어있다면
        if ([username, password, passwordConfirm].includes('')) {
            setError('빈 칸을 모두 입력하세요.');
            return;
        }
        if (password !== passwordConfirm) {
            setError('비밀번호가 일치하지 않습니다.');
            // 입력창 초기화
            // dispatch(initializeForm('register')); // 이렇게 하면 안된다. 입력창에 value 값으로 불러오는 것이 없다.
            // 따라서, 직접 changeField 액션으로 바꿔야 한다.
            //dispatch(changeField({ form: 'register', name: 'password', value: '' }));
            dispatch(authChangeField({ form: 'register', name: 'passwordConfirm', value: '' }));
            return;
        }
        dispatch(register({ username, password }));
    };

    // 컴포넌트가 처음 렌더링될 때 폼을 초기화함
    useEffect(() => {
        dispatch(initializeForm({ form: 'register' }));

    }, [dispatch]);

    // 회원가입 성공/실패 처리. register를 dispatch하고나면 auth, authError state 변경 => 리렌더링
    useEffect(() => {
        if (authError) {
            // 계정명이 이미 존재할 때
            if (authError.status === 409) {
                setError('이미 존재하는 계정입니다.');
                return;
            }
            // 기타 이유
            setError('회원가입 실패');
            return;
        }
        if (auth) {
            // 회원가입 성공 후 check 액션 디스패치
            dispatch(check());
        }
    }, [auth, authError, dispatch]);

    // 회원가입 성공 후 user 값이 잘 설정되었는지 확인. 확인 후 홈('/') 화면으로 이동.
    const navigate = useNavigate();
    useEffect(() => {
        if (user) {
            //console.log('check API 성공');
            //console.log(user);
            navigate('/');
            /*
                로그인 상태 유지를 위해 브라우저에 있는 localStorage를 사용.
                어떻게 사용하나?
                src/index.js에서
                localStorage에서 'user' 를 가져온 후        const user = localStorage.getItem('user');
                로그인 상태가 아니라면 아무것도 하지 않고    if (!user) return;
                로그인 상태라면 tempSetUser 디스패치 후      store.dispatch(tempSetUser(JSON.parse(user)));
                check 디스패치                              store.dispatch(check());
                
            */
            try {
                localStorage.setItem('user', JSON.stringify(user));
            } catch (e) {
                console.error('localStorage is not working');
            }
        }
    }, [user, navigate]);

    return <AuthForm type="register" onChange={onChange} onSubmit={onSubmit} form={form} error={error} />;
};

export default RegisterForm;
